module.exports = __webpack_public_path__ + "static/media/solvana-solar-garden.e2bcd7dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solvana-solar-garden.jpg
// module id = 1195
// module chunks = 0